// extracted by mini-css-extract-plugin
module.exports = {"inner":"RankingsFilter_inner__21PGW","range":"RankingsFilter_range__1KIUH"};